import {
  LandingPageCustom,
  landingPageCustomSchema,
  type LandingPageCustomProps,
} from '../../components/LandingPageCustom';
import { serverLogger } from '../../utils/loggers/server';
import { getCachedEntryByUrl } from '../../utils/requests/contentstack/cachedRequests';

export const getStaticProps = async () => {
  try {
    const entry = await getCachedEntryByUrl({
      contentType: 'landing_page_custom',
      url: '/men/workout-clothes',
      schema: landingPageCustomSchema,
      logger: serverLogger,
    });

    return {
      props: entry.data,
      revalidate: 300,
    };
  } catch (error) {
    serverLogger({
      level: 'error',
      team: 'client-onboarding',
      message: 'Failed to fetch required page data - /men/workout-clothes',
      context: {
        error,
        page: '/men/workout-clothes',
        severity: 'critical',
      },
    });

    throw new Error(
      'Required data not provided to render /men/workout-clothes',
    );
  }
};

const WorkoutClothesPage = ({ seoData, modules }: LandingPageCustomProps) => {
  return <LandingPageCustom seoData={seoData} modules={modules} />;
};

export default WorkoutClothesPage;
